import React, { useState, useEffect } from "react";
import {Helmet} from "react-helmet";
import {
	Link,
	useParams,
} from "react-router-dom";
import moment from 'moment/min/moment-with-locales';
import Moment from 'react-moment';
import WpComments from "react-wordpress-comments";
import "react-wordpress-comments/css/styles.css";
import { createContext, useContext } from 'react';
//import ReactPaginate from 'react-paginate';

//import {sampleSearchItemsApi} from "./sampleSearchItemsApi.js"
//import SyntaxHighlighter from "react-syntax-highlighter";
//import Dark from "react-syntax-highlighter/dist/esm/styles/prism/atom-dark.js";
//import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";

//import { InView, useInView } from "react-intersection-observer";
/*
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,,
} from "react-share";
*/
import {
  EmailShareButton,
  FacebookShareButton,
  //FacebookMessengerShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  EmailIcon,
  FacebookIcon,
  //FacebookMessengerIcon,
  LinkedinIcon,
  PinterestIcon,
  RedditIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";

const TitleinView = ({ title }) => {
	const options = {
		root: null,
		rootMargin: "0px",
		threshold: 1.0,
	};
	//const { ref, inView, entry } = useInView(options);
	return (
		<>
			<h2
				//ref={ref}
				/*className={"h1 " + (inView ? "active" : "")}*/
				className={"h1 " + ("active")}
				dangerouslySetInnerHTML={{ __html: title}}
			></h2>
		</>
	);
};
function Menutop({props}) {
	if (process.env.REACT_APP_POSTTYPE === 'posts') {
		return <>
			<div className={"site-header " +props}><nav className="site-header-i" itemScope itemType="http://schema.org/SiteNavigationElement">
			<Link className="nolink" to={"/"} >Blog</Link>
			<Link className="nolink" to={"/tag/epices/"} >Épices</Link>
			<Link className="nolink" to={"/tag/tisanes-et-thes/"} >Tisanes et Thés</Link>
			<Link className="nolink" to={"/tag/fruits-et-legumes/"} >Fruits et Légumes</Link>
			<Link className="nolink" to={"/tag/fitness/"} >Fitness</Link>
			</nav></div>
			</>
	} else if (process.env.REACT_APP_POSTTYPE === 'nutrition') {
		return <>
			<div className={"site-header " +props}><nav className="site-header-i" itemScope itemType="http://schema.org/SiteNavigationElement">
			<Link className="nolink" to={"/"} >Blog</Link>
			<Link className="nolink" to={"/tag/spices/"} >Spices</Link>
			<Link className="nolink" to={"/tag/herbal-teas/"} >Herbal teas and Teas</Link>
			<Link className="nolink" to={"/tag/fruits-and-vegetables/"} >Fruits and vegetables</Link>
			<Link className="nolink" to={"/tag/fitness/"} >Fitness</Link>
			</nav></div>
			</>
	} else {
		return <></>
	}
}

function NotFound() {
    return (
	<>
	<Helmet>
		<title>404 | page not found</title>
		<link rel="canonical" to={window.location.protocol + "//" + window.location.host + "/404/"} />
	</Helmet>
	<Menutop />
        <div className="main">
            <h1>404 | page not found</h1>
        </div>
	</>
    )
}

function Incentive() {
if (process.env.REACT_APP_POSTTYPE === 'posts') {
return (
<div className="main margint30"><p>Soutenez notre mission en faisant un don : chaque contribution nous aide à continuer à partager, inspirer et éclairer à travers notre site web.</p>
<form action="https://www.paypal.com/donate" method="post" target="_top">
<input type="hidden" name="hosted_button_id" value="UX2ZR2QWX9J6Q" />
<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
</form></div>
)
}
if (process.env.REACT_APP_POSTTYPE === 'nutrition') {
return (
<div className="main margint30"><p>Make a difference today: Your donation helps us keep the website thriving, ensuring we continue to deliver the content that enlightens and inspires you every day.</p>
<form action="https://www.paypal.com/donate" method="post" target="_top">
<input type="hidden" name="hosted_button_id" value="UX2ZR2QWX9J6Q" />
<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
</form></div>
)
} else {
return ('')
}

}

export default function Post() {


	//export default class Post extends Component {
	// We can use the `useParams` hook here to access
	// the dynamic pieces of the URL.
	//const [posts, setPosts] = useState([]);

	//console.log(isLoaded);
	const { slug } = useParams();
const staticContext = createContext({});
if (slug.length <= 4) {
//console.log(staticContext);
if (staticContext) {
      staticContext.statusCode = 404;
    }
return (<NotFound />)
}
  //const [loadedContent, setLoadedContent] = useState();
  //const [loadedSectors, setLoadedSectors] = useState();
//let params = useParams();
	//console.log(slug);
	//const [post, setPost] = useState([]);



	const [isLoaded, setIsLoaded] = useState(false);
	const [posts, setPosts] = useState([]);
	const [images, setImages] = useState([]);

	useEffect(() => {
		//fetch("http://localhost:8080/api/posts/")
		/*fetch("https://www.espace-bien-etre.fr/wp/wp-json/wp/v2/"+process.env.REACT_APP_POSTTYPE+"/?slug="+slug)
			.then((res) => res.json())
			.then(
				(result) => {
					//setIsLoaded(true);
					setPosts(result);
					console.log(posts);
					result.map((item) =>
					fetch("https://www.espace-bien-etre.fr/wp/wp-json/wp/v2/media/"+item.featured_media)
						.then((res) => res.json())
						.then(
							(result) => {
								setIsLoaded(true);
								setImages(result);
								console.log(result);
							},
						)
					.catch(err => {console.log(err)})
					)

				},
			)
		.catch(err => {console.log(err)})*/



const fetchContent = async () => {
    try {
      //...
return fetch("https://www.espace-bien-etre.fr/wp/wp-json/wp/v2/"+process.env.REACT_APP_POSTTYPE+"/?slug="+slug)

    } catch (err) {console.log(err)}
  };

  const fetchSectors = async (firstId) => {
    try {
      //...
//console.log(2)
return fetch("https://www.espace-bien-etre.fr/wp/wp-json/wp/v2/media/"+firstId)

    } catch (err) {console.log(err)}
  };

async function fetch1() {
  const res = await fetchContent(); // get data B first
  const data = await res.json();
  //console.log("Data at the beginning: ", data[0].featured_media);
if (typeof data === 'undefined' || data.length <= 0) {
if (staticContext) {
      staticContext.statusCode = 404;
    }
return (<NotFound />)
}


  const nextRes = await fetchSectors(data[0].featured_media);
  const nextData = await nextRes.json();
let nextData_array = [];
nextData_array.push(nextData);

	setPosts(data);
	setImages(nextData_array);
  //console.log("Data at the end: ", nextData);
}
fetch1();
		
				//(error) => {
				//	setIsLoaded(true);
				//	setError(error);
				//}
			//);
	}, []);


	//const posts = useContext(PostsContext);
	//const images = useContext(ImagesContext);
	let translationOverrides = [];

if (process.env.REACT_APP_LANG_MAIN === 'en') {						
translationOverrides={
						mainHeading: "Comments",
						leaveCommentHeading: "Leave a comment",
						loadingCommentsLabel: "Loading comments...",
						loggedInUserIntro: "",
						respondLinkLabel: "Answer ↓",
						nameInputLabel: "Name*:",
						emailInputLabel: "Email*:",
						commentInputLabel: "Write your comment :",
						commentInputPlaceholder: "Comment...",
						submitButtonLabel: "Send",
						cancelLinkLabel: "Close X",
						commentsClosedNotice: "Comments are closed"
						}
						} else {
translationOverrides={mainHeading: "Commentaires"}
}

let publiele = "";
let ecritpar = "";
let modifiele = "";
//moment.locale('fr');
//console.log(moment.months());
//Moment.globalLocale = 'fr';
Moment.globalMoment = moment;
// Set the output format for every react-moment instance.
if (process.env.REACT_APP_LANG_MAIN === 'en') {	
//Moment.globalLocale = 'fr';
Moment.globalFormat = 'MMM D YYYY';
publiele = "Published on";
ecritpar = "Written by";
modifiele = "modified";
} else {
Moment.globalLocale = 'fr';
Moment.globalFormat = 'D MMMM YYYY';
publiele = "Publié le";
ecritpar = "Écrit par";
modifiele = "Modifié le";
}


//const postsAPI = useContext(AmazonPAAPShareButtontext);
	//console.log("posts");
	//console.log(posts);
//console.log(images);
	//console.log(slug);
/*let user = {
  name: "Maria",
  email: "maria@example.com",*/
  /*jwt: "jwt-string-value",*/
/*}*/

	/*
	useEffect(() => {
		for (const item of posts) {
			// You can use `let` instead of `const` if you like
			if (item.id == slug) {
				setPost(item);
				console.log(item);
			}
		}
		//fetch("http://localhost:8080/api/posts/")
		// fetch("https://www.ondevisuelle.fr/old2/wp-json/wp/v2/posts")
		// 	.then((res) => res.json())
		// 	.then(
		// 		(result) => {
		// 			for (const item of result) {
		// 				if (item.id == slug) {
		// 					setPost(item);
		// 					console.log(item);
		// 				}
		// 			}
		// 		},
		// 		(error) => {
		// 			console.log(error);
		// 		}
		// 	);
	}, []);*/
	//console.log(params.myProp1);

	//console.log(props)
	//{item.title}
	//<img src={item.header} className="header" alt={item.title}/>
	//<div className="content" dangerouslySetInnerHTML={createBody(item)}>
	//</div> {post.title.rendered}
	// post.content.rendered

//<div
								//className="content"
								//dangerouslySetInnerHTML={createBody(item.content.//rendered)}
							//></div>
	return (<>
{posts &&
				posts.map((item) =>
item.slug == slug ? (
images && images.map((itemi) =>
					// ? (
					//{images && images.map((itemi) =>
					

item.featured_media == itemi.id ? (
//console.log(itemi.id),
			<Helmet key={"k2_"+itemi.id}>
			<title>{item.title.rendered.replace('<strong>','').replace('</strong>','')}</title>
			<meta name="description" content={item.excerpt.rendered.replace(/<[^>]+>/g, '')} />
			<meta property="og:url" content={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"} />
			<meta property="og:site_name" content={process.env.REACT_APP_TITLE} />
			<meta property="og:locale" content={process.env.REACT_APP_LANG} />
			<meta property="og:type" content="article" />
			<meta property="og:title" content={item.title.rendered.replace('<strong>','').replace('</strong>','')} />
			<meta property="og:image" content={itemi.guid.rendered} />
			<link rel="canonical" to={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"} />
			</Helmet>		
/*): (
						""
					)
)}
</div>*/
): (
						""
					)
						//""
					)
					//)},
				): ( ""
))}
		<div className="" itemScope itemType="https://schema.org/Article">
{posts &&
					posts.map((item) => (
item.slug == slug ? (
						<div key={"k3_"+item.id}>
							
					{images && images.map((itemi) =>
					itemi.id == item.featured_media ? (
//<div key={item.link}></div>
{/*<Parallax
				key={"k4_"+item.id}
				bgImage={itemi.guid.rendered}
				bgImageAlt={item.title.rendered}
				strength={200}
				className="header_background"
			></Parallax>

<FacebookMessengerShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><FacebookMessengerIcon size={32} round /></FacebookMessengerShareButton>

*/},
			<><Menutop></Menutop><div className="header_background"><img itemProp="image" src={itemi.guid.rendered} alt={item.title.rendered.replace('<strong>','').replace('</strong>','')} /></div></>
					)
					:(""))
					}

						</div>
					) : (
						""
					)
					//)},
				))}

			{posts &&
				posts.map((item) =>
					// ? (

					
					//{images && images.map((itemi) =>
					item.slug == slug ? (
//<div key={item.link}></div><div className="main basdusite">
						//		<Link to="/">&lsaquo; {process.env.//REACT_APP_BACK}</Link>
						//</div>
					<><div key={item.id}><article className="main">
					<div>
						
							<h1
								className="h1"
								itemProp="name"
								dangerouslySetInnerHTML={{ __html: item.title.rendered}}
							></h1>
							<div className="author">{publiele} <span itemProp="datePublished" content={item.date_gmt}><Moment>{item.date_gmt}</Moment></span> | {ecritpar} <span itemProp="author">Gael Green</span> | {modifiele} <span itemProp="datePublished" content={item.modified_gmt}><Moment>{item.modified_gmt}</Moment></span></div>
							<div
								className="content"
								itemProp="articleBody"
								dangerouslySetInnerHTML={{__html: item.acf.contenu.replace(new RegExp('<a href="https://www.amazon.fr', 'g'), '<a rel="nofollow" href="https://www.amazon.fr').replace('<a target="blank" href="https://www.amazon.fr', '<a target="blank" rel="nofollow" href="https://www.amazon.fr').replace('BUY ON AMAZON', 'VIEW PRODUCTS ON AMAZON').replace('SEE PRODUCTS ON AMAZON', 'VIEW PRODUCTS ON AMAZON').replace('ACHETER SUR AMAZON', 'VOIR LES PRODUITS SUR AMAZON').replace(new RegExp('<img ', 'g'), '<img loading="lazy" ')}}
							></div>
					</div>
					</article>
					<div className="main"><div className="social">
					<EmailShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><EmailIcon size={40} round /></EmailShareButton>
					<FacebookShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><FacebookIcon size={40} round /></FacebookShareButton>
					<LinkedinShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><LinkedinIcon size={40} round /></LinkedinShareButton>
					<RedditShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><RedditIcon size={40} round /></RedditShareButton>
					<TwitterShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><TwitterIcon size={40} round /></TwitterShareButton>
					<WhatsappShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"}><WhatsappIcon size={40} round /></WhatsappShareButton>
{images && images.map((itemi) =>
					itemi.id == item.featured_media ? (
					<PinterestShareButton url={window.location.protocol + "//" + window.location.host + "/blog/" + item.slug + "/"} description={item.excerpt.rendered.replace(/<[^>]+>/g, '')} media={itemi.guid.rendered} ><PinterestIcon size={40} round /></PinterestShareButton>
):(''))}
					</div></div>
					<Incentive />
					<div className="main margint20">
					<WpComments
						maxDepth={3} // provide depth that you want comments to be nested in a list
						pageId={item.id} // id of a page you want to fetch comments from and post to
						hostUrl="https://www.espace-bien-etre.fr/wp" // url of your WordPress website
						allowComments={true} // can users post comments?
						//user={user} // provide user if authorized, default is null. See below
						translationOverrides={translationOverrides}
					/>
					</div>
					</div>
					<Menutop props="bas"></Menutop>
					</>
					//)
					) : (
						""
					)
					//)},
				)}
		</div>
		</>
	)
}